import { AdminUserPermissionsEnum } from '@/lib/enum';
import { userHasPermission } from '@/lib/utils.ts';
import { IHasChildren } from '@/lib/interface';
import { useUserConnected } from '@/hooks';
import { ReactNode } from 'react';

interface IProps extends IHasChildren {
  permissionsRequired?: AdminUserPermissionsEnum[] | (() => boolean);
  accessDeniedComponent?: ReactNode;
}

const SecuredComponent = ({ children, permissionsRequired, accessDeniedComponent = <></> }: IProps) => {

  const { userConnected } = useUserConnected();

  let hasPermission = false;

  if (typeof permissionsRequired === 'function') {
    hasPermission = permissionsRequired();
  } else if (!!permissionsRequired) {
    for (let index = 0; index < permissionsRequired.length; index++) {
      const permissionRequired = permissionsRequired[index];
      hasPermission = userHasPermission(userConnected, permissionRequired);

      if (hasPermission) {
        break;
      }
    }
  }

  if (hasPermission || userConnected?.root) {
    return children;
  }

  return accessDeniedComponent;

};

export default SecuredComponent;
